import React from 'react';
import {TextInputElement} from 'types/documentTemplateElement';
import {DocumentTemplate} from '../../../types/documentTemplate';
import BaseInputProperties from './BaseInputProperties';

interface TextInputPropertiesProps {
  element: TextInputElement;
  template: DocumentTemplate;
  updateElement: (updatedElement: TextInputElement) => void;
}

const TextInputProperties: React.FC<TextInputPropertiesProps> = ({
  element,
  template,
  updateElement,
}) => {
  return (
    <BaseInputProperties
      element={element}
      template={template}
      updateElement={updateElement}
    />
  );
};

export default TextInputProperties;
